import { render } from "./UserOtp.vue?vue&type=template&id=7d8cbd11"
import script from "./UserOtp.vue?vue&type=script&lang=js"
export * from "./UserOtp.vue?vue&type=script&lang=js"

import "./UserOtp.vue?vue&type=style&index=0&id=7d8cbd11&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__